"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.BurgerMenuIconRoot = exports.BurgerMenuIconLine = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _styles = require("../styles");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'none',
  [theme.breakpoints.up('md')]: {
    alignItems: 'center',
    display: 'flex',
    height: _presentationUtils.TOP_AREA_NAVIGATION_HEIGHT,
    justifyContent: 'center',
    left: '0',
    position: 'fixed',
    top: `calc(${_presentationUtils.CSS_DESKTOP_WITH_TOP_AREA_BANNER_AND_NAVIGATION_HEIGHT} - ${_presentationUtils.TOP_AREA_NAVIGATION_HEIGHT}px)`,
    width: '100vw',
    zIndex: theme.zIndex.appBar
  },
  [`.${_mui.tabsClasses.root}`]: {
    backgroundColor: theme.palette.common.white
  },
  '&:empty': {
    display: 'none'
  }
}));
const BurgerMenuIconRoot = exports.BurgerMenuIconRoot = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isOpen,
  theme
}) => ({
  alignContent: 'center',
  color: theme.palette.text.primary,
  fontSize: '2.8rem',
  height: 24,
  placeItems: 'center',
  width: 24,
  ...(0, _styles.focusableStyle)(theme),
  '&:hover': {
    '.burgerMenuIconLine': {
      boxShadow: _mui.SHADOW_LEVEL1
    }
  },
  ...(isOpen && {
    '&:hover': {
      '.burgerMenuIconLine': {
        boxShadow: _mui.SHADOW_LEVEL1
      }
    }
  })
}));
const BurgerMenuIconLine = exports.BurgerMenuIconLine = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isOpen,
  theme
}) => ({
  backgroundColor: theme.palette.text.primary,
  height: 1,
  marginBottom: 6,
  opacity: 1,
  position: 'relative',
  transform: 'translateX(0) rotate(0) translateY(0)',
  transition: 'opacity 0.3s linear, transform 0.3s linear',
  width: 15,
  ...(isOpen && {
    '&:nth-of-type(1)': {
      transform: 'rotate(45deg) translateY(5px) translateX(5px)'
    },
    '&:nth-of-type(2)': {
      opacity: 0,
      transform: 'translateX(22px)'
    }
  }),
  '&:nth-of-type(3)': {
    marginBottom: 0,
    ...(isOpen && {
      transform: 'rotate(-45deg) translateY(-5px) translateX(5px);'
    })
  }
}));